import apiClient from '../client';
import type { EquipmentInventory, CreateEquipmentRequest, PaginatedResponse } from '../../types';

const equipmentService = {
  getAll: async (params: { page?: number; size?: number } = {}) => {
    const { page = 0, size = 50 } = params;
    const response = await apiClient.get<PaginatedResponse<EquipmentInventory>>(
      `/equipment?page=${page}&size=${size}&sort=name,asc`
    );
    return response.data;
  },

  getById: async (id: string) => {
    const response = await apiClient.get<EquipmentInventory>(`/equipment/${id}`);
    return response.data;
  },

  getByStatus: async (status: string, params: { page?: number; size?: number } = {}) => {
    const { page = 0, size = 50 } = params;
    const response = await apiClient.get<PaginatedResponse<EquipmentInventory>>(
      `/equipment/status/${status}?page=${page}&size=${size}`
    );
    return response.data;
  },

  getMaintenanceDue: async (daysAhead = 14) => {
    const response = await apiClient.get<EquipmentInventory[]>(
      `/equipment/maintenance-due?daysAhead=${daysAhead}`
    );
    return response.data;
  },

  create: async (data: CreateEquipmentRequest) => {
    const response = await apiClient.post<EquipmentInventory>('/equipment', data);
    return response.data;
  },

  update: async (id: string, data: Partial<CreateEquipmentRequest>) => {
    const response = await apiClient.put<EquipmentInventory>(`/equipment/${id}`, data);
    return response.data;
  },

  delete: async (id: string) => {
    await apiClient.delete(`/equipment/${id}`);
  },

  search: async (params: { page?: number; size?: number; search?: string; type?: string; status?: string; projectId?: string } = {}) => {
    const { page = 0, size = 10, search, type, status, projectId } = params;
    const qs = new URLSearchParams({ page: page.toString(), size: size.toString() });
    if (search) qs.set('search', search);
    if (type) qs.set('type', type);
    if (status) qs.set('status', status);
    if (projectId) qs.set('projectId', projectId);
    const response = await apiClient.get<PaginatedResponse<EquipmentInventory>>(`/equipment/search?${qs}`);
    return response.data;
  },
};

export default equipmentService;
